/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * OpenAPI spec version: 1.0.0
 */

export type ProjectDtoPhase = typeof ProjectDtoPhase[keyof typeof ProjectDtoPhase];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectDtoPhase = {
  Sold: 'Sold',
  Preproduction: 'Preproduction',
  Production: 'Production',
  Postproduction: 'Postproduction',
  Completed: 'Completed',
} as const;
